<template lang="pug">
  #features-settings
    BCollapse.card.mb-5(
      aria-id="Badges"
      :open.sync="badgesOpen"
      animation=""
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='badges'
      )
        .card-header-title
          WtTitle(card-title-large) Badges
        a.card-header-icon
          BIcon(:icon="badgesOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        BadgeSettings

    template(v-if="showPointsFeature")
      BCollapse.card.mb-5(
        aria-id="Points"
        :open.sync="pointsOpen"
        animation=""
        v-if="$auth.user().isAdmin"
      )
        .card-header(
          slot='trigger',
          role='button',
          aria-controls='points'
        )
          .card-header-title
            WtTitle(card-title-large) Points
          a.card-header-icon
            BIcon(:icon="pointsOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
        .column
          PointsSettings

    BCollapse.card.mb-5(
      aria-id="mentalWellness"
      :open.sync="mentalWellnessOpen"
      animation=""
      v-if="$auth.user().isWtAdmin"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='mentalWellness'
      )
        .card-header-title
          div
            p.has-text-danger(v-if="$auth.user().isWtAdmin") SuperAdmin ONLY
            WtTitle(card-title-large) Mental Wellness
        a.card-header-icon
          BIcon(:icon="mentalWellnessOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        MentalWellnessSettings

    BCollapse.card.mb-5(
      aria-id="wellnessMetricsFeature"
      :open.sync="wellnessMetricsFeatureOpen"
      animation=""
      v-if="$auth.user().isWtAdmin"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='wellnessMetricsFeature'
      )
        .card-header-title
          div
            p.has-text-danger(v-if="$auth.user().isWtAdmin") SuperAdmin ONLY
            WtTitle(card-title-large) Wellness Metrics/Challenges
        a.card-header-icon
          BIcon(:icon="wellnessMetricsFeatureOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        WellnessMetricsFeatureSettings
</template>

<script>
import { mapGetters } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import BadgeSettings from "@@/BadgeSettingsAdmin/BadgeSettings";
import PointsSettings from "@@/ProgramSettingsAdmin/PointsSettings";
import WellnessMetricsFeatureSettings from "@@/ProgramSettingsAdmin/WellnessMetricsFeatureSettings";
import MentalWellnessSettings from "@@/MentalWellnessSettings/MentalWellnessSettings.vue";

export default {
  name: "FeaturesSettings",

  components: {
    WtTile,
    WtTitle,
    BadgeSettings,
    PointsSettings,
    WellnessMetricsFeatureSettings,
    MentalWellnessSettings
  },

  data() {
    return {
      badgesOpen: false,
      pointsOpen: false,
      mentalWellnessOpen: false,
      wellnessMetricsFeatureOpen: false
    };
  },

  computed: {
    ...mapGetters("program", ["isCoreTier"]),

    showPointsFeature() {
      return true;
    }
  }
};
</script>

<style lang="sass" scoped>
.custom-collapse
  overflow: visible // for the tooltip
.card-header
  min-height: 3.5rem
</style>
